import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { GigyaService } from '../../services/gigya.service';
import { OrganizationPickerService } from '../../services/organization-picker.service';
import { InputComponent } from '../../shared/input/input.component';
import { ButtonComponent } from '../../shared/button/button.component';
import { SpinnerComponent } from '../../shared/icons/spinner/spinner.component';
import { WarningIconComponent } from '../../shared/icons/warning/warning.component';
import { LayoutComponent } from '../../shared/layout/layout.component';
import { TitleUnderlineIconComponent } from '../../shared/icons/title-underline/title-underline.component';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'app-email-otp',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterLink,
    TranslatePipe,
    InputComponent,
    ButtonComponent,
    SpinnerComponent,
    WarningIconComponent,
    LayoutComponent,
    TitleUnderlineIconComponent,
  ],
  templateUrl: './email-otp.component.html',
  styleUrl: './email-otp.component.css',
})
export class EmailOtpComponent implements OnInit {
  error: string | null = null;
  loading = false;
  sendLoading = false;
  email = '';

  form: FormGroup = new FormGroup({
    code: new FormControl('', Validators.required),
  });

  constructor(
    private route: ActivatedRoute,
    private gigyaService: GigyaService,
    private organizationPicker: OrganizationPickerService,
    private translateService: TranslateService,
    public versionService: VersionService,
  ) { }

  public ngOnInit(): void {
    this.email = this.route.snapshot.queryParams['email'] ?? '';
    this.sendCode();
  }

  public async sendCode(): Promise<void> {
    this.sendLoading = true;
    this.error = null;

    const res = await this.gigyaService.execute(this.gigyaService.client.accounts.auth.otp.email.sendCode, {
      email: "mathieu.delacroix@nslogin.nl",
    });

    this.sendLoading = false;
    if (res.errorCode !== 0) {
      this.error = this.translateService.instant('emailOtp.sendError');
    }
  }

  public async onSubmit(): Promise<void> {
    if (!this.form.valid) return;
    this.loading = true;
    this.error = null;

    const res = await this.gigyaService.execute(this.gigyaService.client.accounts.auth.otp.email.login, {
      identifier: this.email,
      code: this.form.controls['code'].value,
    });

    if (res.errorCode !== 0) {
      this.loading = false;
      this.error = this.translateService.instant('emailOtp.invalidCode');
      return;
    }
    await this.organizationPicker.proceed();
  }
}
